import { parseISO } from 'date-fns';

export type BookingClientFormSource = {
    firstName?: string;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    vatNumber?: string | null;
    unsubscribed?: boolean | null;
    dob?: string | null;
};

export function getSubscribedFormValue(client: { unsubscribed?: boolean | null } | null | undefined): boolean {
    return client?.unsubscribed ? false : true;
}

export function getUnsubscribedPayloadValue(
    subscribed: boolean,
    existingClient?: { unsubscribed?: boolean | null } | null,
): boolean | undefined {
    if (existingClient && typeof existingClient.unsubscribed !== 'boolean') {
        return undefined;
    }

    return subscribed === false;
}

export function getBookingClientFormPatch(client: BookingClientFormSource | null | undefined, customFields: unknown) {
    return {
        email: client?.email,
        phoneNumber: client?.phoneNumber,
        client_name: client?.lastName ? `${client.firstName} ${client.lastName}` : client?.firstName,
        vatNumber: client?.vatNumber,
        subscribed: getSubscribedFormValue(client),
        dob: client?.dob ? parseISO(client.dob) : null,
        customFields,
    };
}
